/**
 * テレビデモ 画面2〜4の表示地点（2択）
 */

export const TV_SPOT_IDS = {
  STATION: 'station',
  OLD_TOWN: 'old-town',
};

export const TV_SPOT_DEFAULT = TV_SPOT_IDS.STATION;

export const TV_SPOT_LOCATION_OPTIONS = [
  {
    id: TV_SPOT_IDS.STATION,
    label: '高山駅前',
    shortLabel: '駅前',
    imageSrc: '/assets/station-eyecatch.png',
  },
  {
    id: TV_SPOT_IDS.OLD_TOWN,
    label: '古い町並み',
    shortLabel: '古い町並み',
    imageSrc: '/assets/old-town-eyecatch.png',
  },
];

/** @deprecated TV_SPOT_IDS.STATION を使用 */
export const TV_STATION_ID = TV_SPOT_IDS.STATION;

/** @deprecated 地点ごとの imageSrc は TV_SPOT_LOCATION_OPTIONS を参照 */
export const TV_STATION_IMAGE = TV_SPOT_LOCATION_OPTIONS[0].imageSrc;

export function getTvSpotConfig(spotId) {
  return TV_SPOT_LOCATION_OPTIONS.find((o) => o.id === spotId) || TV_SPOT_LOCATION_OPTIONS[0];
}

export function getTvSpotPanelTitles(spotId) {
  const { label } = getTvSpotConfig(spotId);
  return {
    today: `${label} · 今日の人通り`,
    tomorrow: `${label} · 明日の人通り`,
    dayAfter: `${label} · 明後日の人通り`,
    week: `${label} · 1週間の流れ`,
    pastWeek: `${label} · 過去1週間の流れ`,
  };
}
